module.exports = "/virtual-football-league/img/amblems/left/logos/Leg.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Leg.png
// module id = 2102
// module chunks = 4